import { Layers2Icon } from 'lucide-react'
import React, { Dispatch, FC, SetStateAction } from 'react'
import styled from 'styled-components'

const ButtonContainer = styled.div<{ $selected: boolean }>`
  cursor: pointer;
  width: 50px;
  height: 50px;
  border-radius: 1rem;
  background-color: ${({ $selected, theme }) =>
    $selected ? theme.forecast.secondaryText : theme.forecast.background2_5};
  color: ${({ $selected, theme }) =>
    $selected ? theme.forecast.background2_5 : theme.forecast.secondaryText};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${({ $selected, theme }) =>
      $selected ? theme.forecast.defaultText : theme.forecast.background3};
    width: 56px;
    height: 56px;
  }
`

const StyledLayerIcon = styled(Layers2Icon)`
  width: 80%;
  height: 80%;
`

interface MapPlusButtonProps {
  isSelected: boolean
  setIsSelected: Dispatch<SetStateAction<boolean>>
}

export const OpenLayersButton: FC<MapPlusButtonProps> = (props) => {
  return (
    <ButtonContainer
      $selected={props.isSelected}
      onClick={() => props.setIsSelected(!props.isSelected)}>
      <StyledLayerIcon />
    </ButtonContainer>
  )
}
